import { render, staticRenderFns } from "./EditorWrapper.vue?vue&type=template&id=4bffde70&scoped=true&"
import script from "./EditorWrapper.vue?vue&type=script&lang=ts&"
export * from "./EditorWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./EditorWrapper.vue?vue&type=style&index=0&id=4bffde70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bffde70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VSpacer})
